/**
 * The face-shape vocabulary.
 *
 * Deliberately its own enum and never `FrameShape`. They share the words ROUND, SQUARE and OVAL and mean opposite things by them: `FrameShape` describes the glasses, `FaceShape` describes the person wearing them, and the conventional advice pairs a round face with a frame that is not round. Joining the two would invert every recommendation. Phase 4D holds the mapping between them, explicitly.
 */
export const FaceShape = {
  OVAL: 'OVAL',
  ROUND: 'ROUND',
  SQUARE: 'SQUARE',
  OBLONG: 'OBLONG',
  HEART: 'HEART',
  DIAMOND: 'DIAMOND',
  TRIANGLE: 'TRIANGLE',
  /** Measured well, but sitting between two named shapes. The two are kept. */
  MIXED: 'MIXED',
  /** No trustworthy answer: the geometry was refused, or nothing matched strongly enough. */
  UNKNOWN: 'UNKNOWN',
} as const;
export type FaceShape = (typeof FaceShape)[keyof typeof FaceShape];

/** The seven shapes a rule can score. MIXED and UNKNOWN are decisions about those scores, never scored themselves. */
export const NAMED_SHAPES = [
  FaceShape.OVAL,
  FaceShape.ROUND,
  FaceShape.SQUARE,
  FaceShape.OBLONG,
  FaceShape.HEART,
  FaceShape.DIAMOND,
  FaceShape.TRIANGLE,
] as const;
export type NamedFaceShape = (typeof NAMED_SHAPES)[number];
